import { IPromise } from 'angular';
import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';
import { PagingResultsDTO } from '@manager-base/data/dtos/paging-results.dto';
import { ArchitecturalRequestSummaryDTO } from '@manager-base/data/dtos/associations/architectural-request-summary.dto';
import { AssociationArchitecturalRequestResidentEnabledDTO } from '@manager-base/data/dtos/associations/association-architectural-request-resident-enabled.dto';
import { LatestArchitecturalRequestSummariesDTO } from '@root/manager-base/data/dtos/associations/latest-architectural-request-summaries.dto';
import { ArchitecturalRequestCountsByAssociationDTO } from '@root/manager-base/data/dtos/associations/architectural-request-counts-by-association.dto';

const actions = {
    getArchitecturalRequests: {
        method: 'GET',
        url: `${BASE_PATH_API}/v1/associations/architecturalRequests`,
    },

    getResidentEnabledAssociations: {
        method: 'GET',
        url: `${BASE_PATH_API}/v1/associations/architecturalRequests/settings/residentEnabled`,
    },

    getLatestArchitecturalRequestSummaries: {
        method: 'GET',
        url: `${BASE_PATH_API}/v1/associations/architecturalRequests/latest`,
    },

    getArchitecturalRequestCountsByAssociation: {
        method: 'GET',
        url: `${BASE_PATH_API}/v1/associations/architecturalRequests/counts`,
    },
};

export interface IArchitecturalRequestsApi {
    getArchitecturalRequests(params: { skip?: number, take?: number, orderBy?: string, orderByAscending?: boolean }): IPromise<PagingResultsDTO<ArchitecturalRequestSummaryDTO>>;
    getResidentEnabledAssociations(): IPromise<AssociationArchitecturalRequestResidentEnabledDTO[]>;
    getLatestArchitecturalRequestSummaries(): IPromise<LatestArchitecturalRequestSummariesDTO>;
    getArchitecturalRequestCountsByAssociation(): IPromise<ArchitecturalRequestCountsByAssociationDTO>;
}

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function ArchitecturalRequestsApi(): IArchitecturalRequestsApi {
    return createActions(actions);
}
